import React, { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import {Button, Text, TextInput, PasswordInput, Title, Flex, Card} from '@mantine/core';
import { register } from '../service/authService';

const Register = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState('');

    const navigate = useNavigate();

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        await register(email, password);

        navigate('/verify-hint?email=' + email);
    };

    return (<Flex justify={"center"} align={"center"} h={"100vh"} >
            <Flex align={"flex-start"} direction={"column"}>
                <Title order={2} mb="md">
                    Registrierung
                </Title>
                <Card
                    w={"400px"}
                    component="form"
                    onSubmit={handleSubmit}
                >


                    <TextInput
                        label="E-Mail"
                        type="text"
                        value={email}
                        onChange={(event) => setEmail(event.currentTarget.value)}
                        required
                        mb="md"
                    />

                    <PasswordInput
                        label="Passwort"
                        value={password}
                        onChange={(event) => setPassword(event.currentTarget.value)}
                        required
                        mb="md"
                    />
                    <Flex w={"100%"} justify={"flex-end"}>
                        <Button type="submit" variant={"filled"}>
                            Registrieren
                        </Button>
                    </Flex>
                </Card>

                <Flex  align={"center"} direction={"row"} mt={"15px"} gap={"5px"}>
                    <Text>Bereits registriert? Klicke</Text>
                    <Button p={"0px"} variant="transparent" onClick={() => navigate('/login')}>
                        hier
                    </Button>
                    <Text>um anzumelden</Text>
                </Flex>
            </Flex>
    </Flex>

    );
};

export default Register;